
<template>
	<div class="listbox">
		<div class="tabtit">
			<ul>
				<li class="hover"><router-link to="/MyTailPays">补交尾款</router-link></li>
				<li><router-link to="/MyAuc">我的拍卖</router-link></li>
				<li><router-link to="/MyReceive">我的领取</router-link></li>
			</ul>
		</div>
		<div class="tabcont">
			<div class="itembox active">
				<p class="listiti" :data="tailPays" border style="width: 100%" size="mini">
					<span prop="productName" label="物品名称">物品名称</span>
					<span prop="productId" label="物品ID">物品ID</span>
					<span prop="priceMarkupTime" label="竞价时间">竞价时间</span>
					<span prop="paidPrice" label="保证金" :formatter="formatterPrice">保证金</span>
					<span prop="totalPrice" label="成交金额" :formatter="formatterPrice">成交金额</span>
					<span prop="unPrice" label="需要补款金额"	:formatter="formatterPrice">需要补款金额</span>					
					<span prop="tailMoneyEndTime" label="补款结束时间">补款结束时间</span>
					<span label="操作">操作</span>
				</p>
				<div class="weiklist">
					<ul>
						<li v-for="item in tailPays" :key="item.id">
							<span class="span1">{{item.productName}}</span>
							<span class="span2">{{item.productId}}</span>
							<span class="span3">{{item.priceMarkupTime}}</span>
							<span class="span4">{{item.paidPrice}}{{currencyTypeToStr(item.currencyType)}}</span>
							<span class="span5">{{item.totalPrice}}{{currencyTypeToStr(item.currencyType)}}</span>
							<span class="span6">{{item.unPrice}}{{currencyTypeToStr(item.currencyType)}}</span>
							<span class="span7">{{item.tailMoneyEndTime}}</span>
							<span class="span8">
								<em @click="payBackBtn(item)">确认补款</em>
							</span>
						</li>
					</ul>
				</div>
				<div class="page">
					<el-pagination background @size-change="sizeChange" @current-change="currentChange" layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
				</div>
			</div>		
		</div>

		<el-dialog :visible="lackCoinDiaLogVisible" title="确认补款" @close="lackCoinDiaLogHandleClose" :before-close="lackCoinDiaLogHandleClose">
			{{ currencyTypeToStr(tailMoneyDTO.currencyType) }}不足， 需要购买{{currencyTypeToStr(tailMoneyDTO.currencyType)}}后确认补款 补缴{{ tailMoneyDTO.unPrice}}{{ currencyTypeToStr(tailMoneyDTO.currencyType) }}
			<el-button>
				<el-link href="http://newshop.ourgame.com/" underline="true" type="primary">去购买</el-link>
			</el-button>
		</el-dialog>

		<el-dialog :visible="coinDiaLogVisible" title="确认补款" @close="coinDiaLogHandleClose" :before-close="coinDiaLogHandleClose">
			需要支付{{ tailMoneyDTO.unPrice }}{{ currencyTypeToStr(tailMoneyDTO.currencyType) }}
			<el-button type="danger" @click="confirmPayBack()">确认</el-button>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		//我的待支付尾款
		name: "MyTailPays",
		data: function() {
			return {
				//访问前缀，用于区分环境，访问api时使用
				service_url: process.env.VUE_APP_SERVICE_URL ? process.env.VUE_APP_SERVICE_URL : "",
				tailPays: [],
				total: 0,
				currentPage: 1,
				currentSize: 10,
				lackCoinDiaLogVisible: false,
				coinDiaLogVisible: false,
				tailMoneyDTO: {
					bidId: 0,
					productName: "",
					productId: "",
					//出价时间
					priceMarkupTime: "",
					//已付价格，预付款算定金
					paidPrice: 0,
					//未付价格
					unPrice: 0,
					//总价
					totalPrice: 0,
					currencyType: 0,
					//尾款最后结算时间
					tailMoneyEndTime: "",
				},
			};
		},
		methods: {
			sizeChange(size) {
				this.currentSize = size;
				this.initTailMoneyPage();
			},
			currentChange(page) {
				this.currentPage = page;
				this.initTailMoneyPage();
			},
			lackCoinDiaLogHandleClose() {
				this.lackCoinDiaLogVisible = false;
			},
			coinDiaLogHandleClose() {
				this.coinDiaLogVisible = false;
			},
			initTailMoneyPage() {
				this.getRequest(this.service_url + "/aucProduct/tailMoneyPage?current=" + this.currentPage + "&size=" + this.currentSize).then((resp) => {
					if (resp && resp.code == 0) {
						this.tailPays = resp.data.records;
						this.total = resp.data.total;
					}
				});
			},
			//补缴尾款，做弹出层和支付币判断
			payBackBtn(tailMoneyDTO) {
				console.log(tailMoneyDTO);
				this.tailMoneyDTO = tailMoneyDTO;
				this.coinDiaLogVisible = true;
			},
			//确认补缴
			confirmPayBack() {
				this.postRequest(this.service_url + "/aucProduct/tailMoney?bidId=" + this.tailMoneyDTO.bidId).then((resp) => {
					if (resp) {						
						if (resp.code == 0) {
							this.$refs.aucHeader.INIT_USERINFO();
							this.$refs.aucHeader.INIT_TAILMONEYCOUNT();
							this.getRequest(this.service_url + "/aucProduct/tailMoneyPage?current=" + this.currentPage + "&size=" + this.currentSize).then((resp) =>
							{
								if (resp && resp.code == 0) {
									this.tailPays = resp.data.records;
									this.total = resp.data.total;
								}
							});
						}

						//未找到待支付尾款项
						if (resp.code == 20013) {
							this.$message.error(resp.msg);
						}
						//竞拍已结束
						if (resp.code == 20003) {
							this.$message.error(resp.msg);
						}
						//尾款最后结算时间已过
						if (resp.code == 20014) {
							this.$message.error(resp.msg);
						}
						
						//联众币不足
						if (resp.code == 20009) {
							this.$message.error(resp.msg);
							this.lackCoinDiaLogVisible = true;
						}

						//游乐豆不足
						if (resp.code == 20010) {
							this.$message.error(resp.msg);
							this.lackCoinDiaLogVisible = true;
						}

						//会员天数不足
						if (resp.code == 20011) {
							this.$message.error(resp.msg);
							this.lackCoinDiaLogVisible = true;
						}

                        //可转移会员天数不足
                        if (resp.code == 20019) {
                            this.$message.error(resp.msg);
                            this.lackCoinDiaLogVisible = true;
                        }
						this.coinDiaLogVisible = false;
					}
				});
			},
			currencyTypeToStr(type) {
				if (type == "0" || type == 0) {
					return "联众币";
				}
				if (type == "1" || type == 1) {
					return "游乐豆";
				}
				if (type == "2" || type == 2) {
					return "天(会员天数)";
				}
                if (type == "3" || type == 3) {
                    return "天(可转移会员天数)";
                }
			},
			formatterPrice: function(row, column, cellValue) {
				if (row.currencyType == "0" || row.currencyType == 0) {
					return cellValue + "联众币";
				} else if (row.currencyType == "1" || row.currencyType == 1) {
					return cellValue + "游乐豆";
				} else if (row.currencyType == "2" || row.currencyType == 2) {
					return cellValue + "天(会员天数)";
				} else if (row.currencyType == "3" || row.currencyType == 3) {
                    return cellValue + "天(可转移会员天数)";
                }
			},
		},
		created() {
			this.initTailMoneyPage();
		},
	};
</script>
<style>
	.listbox { width: 1008px; margin: 0 auto; padding-top: 30px; }
	.tabtit { height: 50px; line-height: 50px; overflow: hidden; border-bottom: 1px #ce2c00 solid; }
	.tabtit ul { height: 50px; line-height: 50px; overflow: hidden; }
	.tabtit li { width: 134px; height: 50px; border: 1px #f0f0f0 solid; text-align: center; line-height: 50px; float: left; color: #151515; cursor: pointer; font-size: 14px; }
	.tabtit li a { display: block; width: 134px; height: 50px; color: #151515; text-decoration: none; }
	.tabtit li.hover { background: #ce2c00; color: #fff; }
	.tabtit li.hover a { color: #fff; }
	.tabcont { padding-top: 38px; }
	.tabcont .itembox { display: none; width: 958px; margin: 0 auto; }
	.tabcont .active { display: block; }
	.tabcont .itembox .listiti { text-align: center; background: #f2f2f2; color: #333; height: 38px; border: 1px #ccc solid; overflow: hidden; }
	.tabcont .itembox .listiti span { display: block; float: left; width: 119px; text-align: center; line-height: 38px; font-size: 14px; }
	.tabcont .itembox .listitilq { text-align: center; background: #f2f2f2; color: #333; height: 38px; border: 1px #ccc solid; overflow: hidden; }
	.tabcont .itembox .listitilq span { display: block; float: left; width: 95px; text-align: center; line-height: 38px; font-size: 14px; }
	.weiklist { width: 958px; margin: 0 auto; border-left: 1px #dcdcdc solid; border-right: 1px #dcdcdc solid; }
	.weiklist ul {}
	.weiklist ul li { height: 30px; overflow: hidden; line-height: 38px; font-size: 12px; color: #333; border-bottom: 1px #ccc solid; }
	.weiklist ul li span { display: block; text-align: center; line-height: 30px; float: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
	.weiklist ul li .span1 { width: 115px; }
	.weiklist ul li .span2 { width: 115px; }
	.weiklist ul li .span3 { width: 125px; }
	.weiklist ul li .span4 { width: 118px; }
	.weiklist ul li .span5 { width: 122px; }
	.weiklist ul li .span6 { width: 120px; }
	.weiklist ul li .span7 { width: 123px; }
	.weiklist ul li .span8 { width: 120px; }
	.weiklist ul li .span8 em { display: block; width: 62px; height: 24px; text-align: center; line-height: 24px; color: #fff; font-size: 12px; background: #d90000; margin: 3px auto 0; cursor: pointer; }
	.weiklist ul li:nth-child(even) { background: #f8f8f8; }
	.page { padding: 15px 0; text-align: center; }
	.el-pagination__rightwrapper,.el-pagination__sizes,.el-pagination__jump { display: none; }
	.el-pagination span:not([class*=suffix]) {  display: none; }
	.el-pager li { float: left; }
</style>
